/*
 * Copyright (c) 2022. Nedaware SL
 */

import {PropertyTypeInterface} from "./property-type-interface";
import {TypeStr} from './type-str';
import {JsonCaster} from "../casters/json-caster";
import {Type} from '@angular/core';

const objectCaster = new JsonCaster();

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
export class ObjectType extends PropertyTypeInterface {
    public readonly validators = null;
    public readonly expectedApiTypes = ['object'];
    public stringCaster = objectCaster;
    public readonly objectModel: Type<any> | null = null;

    constructor(objectModel: Type<any> | null = null) {
        super();
        this.objectModel = objectModel;
    }

    asObject(): ObjectType {
        return this;
    }

    toString(): TypeStr {
        return TypeStr.Object;
    }
}
